import { render } from "./MobileMessageWidget.vue?vue&type=template&id=31bef135&scoped=true"
import script from "./MobileMessageWidget.vue?vue&type=script&lang=js"
export * from "./MobileMessageWidget.vue?vue&type=script&lang=js"

import "./MobileMessageWidget.vue?vue&type=style&index=0&id=31bef135&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bef135"]])

export default __exports__